export default __webpack_public_path__ + "static/media/Step 4 Image.24ec1ab9.png";